// Shared utility for determining visual style across the application

// Determine visual style for consistent AI image generation
export const determineVisualStyle = (analysis) => {
  const genres = analysis.genres || ['Drama']
  const format = analysis.format || 'Feature Film'
  const tone = analysis.tone || 'professional'
  
  // Animation detection
  if (analysis.synopsis?.toLowerCase().includes('animated') || 
      analysis.synopsis?.toLowerCase().includes('animation') ||
      genres.some(g => g.toLowerCase().includes('animated'))) {
    
    if (genres.includes('Comedy') || format.includes('Micro')) {
      return {
        style: 'Bright colorful 2D animation style',
        description: 'vibrant cartoon animation with expressive characters and dynamic action'
      }
    } else if (genres.includes('Action') || genres.includes('Adventure')) {
      return {
        style: 'Anime-inspired cinematic style',
        description: 'dynamic anime-style animation with detailed backgrounds and dramatic action sequences'
      }
    } else {
      return {
        style: 'Stylized 3D family animation style',
        description: 'polished 3D animated style with expressive characters and detailed environments'
      }
    }
  }
  
  // Live-action style determination
  if (format.includes('Micro') || format.includes('Series')) {
    if (genres.includes('Horror') || genres.includes('Thriller')) {
      return {
        style: 'Handheld found-footage horror style',
        description: 'gritty handheld cinematography with atmospheric lighting and realistic textures'
      }
    } else if (genres.includes('Comedy')) {
      return {
        style: 'Single-camera comedy-drama style',
        description: 'modern TV production quality with natural lighting and contemporary settings'
      }
    } else {
      return {
        style: 'Streaming drama series style',
        description: 'high-quality TV production with cinematic lighting and professional composition'
      }
    }
  }
  
  // Feature film styles
  if (genres.includes('Horror')) {
    return {
      style: 'Neo-noir thriller style',
      description: 'dark atmospheric cinematography with dramatic shadows and moody lighting'
    }
  } else if (genres.includes('Action') || genres.includes('Adventure')) {
    return {
      style: 'Epic blockbuster with large-scale visual effects',
      description: 'cinematic blockbuster quality with dynamic action and spectacular visuals'
    }
  } else if (genres.includes('Romance')) {
    return {
      style: 'Romantic comedy film style',
      description: 'warm cinematic style with soft lighting and beautiful compositions'
    }
  } else if (genres.includes('Sci-Fi')) {
    return {
      style: 'Cyberpunk neon-dystopian style',
      description: 'futuristic visual style with neon lighting and high-tech environments'
    }
  } else if (genres.includes('Fantasy')) {
    return {
      style: 'Epic medieval fantasy style',
      description: 'cinematic fantasy style with rich textures and magical atmospheric lighting'
    }
  }
  
  // Default feature film style
  return {
    style: 'Feature film cinematic style',
    description: 'professional cinematic quality with dramatic lighting and polished composition'
  }
}
